import axios from "axios";
import { useQuery, useQueryClient } from "react-query";
import { useApplication } from "../../../../context/ApplicationContext";
import { config } from "../../../../config/common";
import { IGraduatesApplication, IGraduatesApplicationQuery } from "../types";
import {
  GET_GRADUATES_APPLICATION_DATA,
  GET_GRADUATES_APPLICATION_DATA_QUERY,
} from "../constants";

export default function useGetGradsApplicationData() {
  const queryClient = useQueryClient();

  return queryClient.getQueryData<IGraduatesApplication>(
    GET_GRADUATES_APPLICATION_DATA
  );
}

export function useGetQueryGradsApplicationData() {
  const queryClient = useQueryClient();
  const { onlineApplicationId, securityKey } = useApplication();

  const query = useQuery(GET_GRADUATES_APPLICATION_DATA_QUERY, async () => {
    const result = await axios.get<IGraduatesApplicationQuery>(
      `${config.userAccountApiUrl}/application/graduate/review`,
      { params: { onlineApplicationId, securityKey } }
    );

    return result.data;
  });

  const invalidate = async () =>
    queryClient.invalidateQueries([GET_GRADUATES_APPLICATION_DATA_QUERY]);

  return { ...query, invalidate };
}
